var m = require('mithril');
var R = require('ramda');
var moment = require('moment-timezone');
var loaders = require('../layout/components/loaders');
var alarmState = require('./alarmState');
var button = require('../components/button');
var modal = require('../layout/components/modal');
var commentModal = require('../data/components/commentAlarmModal');
var pagination = require('../data/components/pagination');
var longDateFormat = 'MM-DD-YY hh:mm:ss.SSSS a';
var shortDateFormat = 'MM-DD-YYYY hh:mm:ss a';

var trippedOrPendingReset = R.flip(R.contains)(['Alarm Tripped', 'Pending Alarm Reset']); //bool
var isActive = R.propSatisfies(trippedOrPendingReset, 'alarmStatus'); //bool

function oninit (vnode) {
  const ctrl = this;
  ctrl.parentCtrl = vnode.attrs.parentCtrl;
  ctrl.pointRecord = vnode.attrs.pointRecord;
  ctrl.opened = false;
  ctrl.page = 0,
  ctrl.incidents = [];

  ctrl.getIncidents = function(record){
    loaders.requestWithLoader({
      loader: 'background',
      method: 'GET',
      url: '/api/v1/incident/',
      params: {ids: JSON.stringify([...record.in_Of.map(o => o.out['@rid'])].reverse().slice(0,100))}
    })
    .then(function (incidents) {
      incidents.forEach(incident => ctrl.incidents.push(incident));
      ctrl.incidents.sort((a,b) => b.timestamp - a.timestamp);
      m.redraw();
    })
  }

  ctrl.open = function (record) {
    ctrl.opened = !ctrl.opened;
    m.redraw();
    if (ctrl.opened && ctrl.incidents.length == 0) {
      ctrl.getIncidents(record)
    }
  }

  modal.on('closed', function () {
    ctrl.incidents = [];
    ctrl.getIncidents(ctrl.pointRecord);
  });
  
}

function view () {
  var ctrl = this;
  var acknowledged = Number(ctrl.pointRecord.acknowledged) === 1;
  var eventDivClasses = [
    'ba pa3 bw1 mv2',
    (function () {
      if (isActive(ctrl.pointRecord) && acknowledged) {
        return 'b--blue';
      } else if (isActive(ctrl.pointRecord) && !acknowledged) {
        return 'b--red';
      } else if (!isActive(ctrl.pointRecord) && acknowledged) {
        return 'b--inactive-ack-blue';
      }
      return 'b--grey';
    }()),
  ].join(' ');

  var iconClasses = [
    'icon',
    'fr',
    (ctrl.opened ? ' ion-chevron-up' : ' ion-chevron-down'),
  ].join(' ');

  var lastIncident = Array.isArray(ctrl.pointRecord.in_Of) && ctrl.pointRecord.in_Of.length ? ctrl.pointRecord.in_Of[ctrl.pointRecord.in_Of.length - 1].out : undefined;
  var alarmName;
  if (lastIncident && lastIncident.name) {
    alarmName = lastIncident.name;
  } else {
    alarmName = ctrl.pointRecord.alarmName
  }

  var hasError = alarmState.hasAlarmError(ctrl.pointRecord);
  var alarmErrorBadge = hasError ? m('span.ml2.yellow', '⚠️ Error') : null;
  return m('div', { class: eventDivClasses, id: `event-panel-${ctrl.pointRecord.nrId}`, key: ctrl.pointRecord['@rid'] }, [
    m('div', { onclick: ctrl.open.bind(ctrl, ctrl.pointRecord) }, [
      m('label', { class: 'event-label' }, [
        `${alarmName} `,
        alarmErrorBadge
      ]),
      m('label', { class: 'event-timestamp ml2' }, ctrl.pointRecord.lastTripTimestamp ? moment(ctrl.pointRecord.lastTripTimestamp).format(shortDateFormat) : ''),
      m('i', { class: iconClasses }),
    ]),
    m('div', { id: `event-body-${ctrl.pointRecord['@rid']}`, class: (ctrl.opened ? '' : 'dn') }, [
      m('div.panel.panel-body', [
        m('p', ctrl.pointRecord.alarmDescription),
        m('p.f2', `Status: ${ctrl.pointRecord.alarmStatus ? ctrl.pointRecord.alarmStatus : 'Clear'}${hasError ? ' (Error)' : ''}`),
        m('div.acknowledge-control', [
          m(button, {
            func: m.route.set.bind(null, `/point/${ctrl.pointRecord['@rid'].slice(1)}`),
            label: 'Detail',
          }),
        ]),
        m('p.f2.page-header', 'History'),
        m('table', { class: 'table w-100 mb3' }, ctrl.incidents.map(incident => {
          if (incident) {
            return m('tbody', [
              m('tr', [
                m('td', incident.type || ''),
                m('td', incident.timestamp ? moment(incident.timestamp).format(longDateFormat) : ''),
                m('td.nowrap.tc', {style: {'width': '160px'}}, [
                  (function () {
                    if (incident.snapshot && incident.snapshot == 'available') {
                      return m(m.route.Link, 
                        {
                          class:'f3',
                          href: '/snapshot/' + incident['@rid'].slice(1)
                        }, 
                        'View Waveform'
                      );
                    } else if (incident.snapshot && incident.snapshot == 'Error Retrieving Snapshot') {
                      return m('span.f3.red', 'Waveform Error');
                    } else if (incident.snapshot && incident.snapshot == 'Downloading... ') {
                      return m('span.f3', 'Downloading... ');
                    } else {
                      return ''
                    }
                  })()
                ]),
                m('td.tc', incident.acknowledged == 1 ? 'Acknowledged' : ''),
                m('td.tc', [
                  m('i.ion-android-chat.blue.ml1.pointer', {
                    onclick: commentModal.editDialogue.bind(commentModal, incident)                    
                  },"     " + (incident.out_SubjectOf ? incident.out_SubjectOf.length : 0)),
                ]),
              ])
            ])
          }
        })),
        (()=>{
          if (ctrl.incidents.length > 0 ) {
            return m(pagination, {
              data: ctrl.incidents
            })
          }
        })(),
        m('div.cf', [
          m(button, {
            class: 'fr',
            func: () => {
              return ctrl.parentCtrl.ackEvent(ctrl.incidents[0]["@rid"])
            },
            label: (ctrl.pointRecord.alarmStatus === 'Alarm Tripped' ? 'Acknowledge' : 'Clear'),
          }),
        ])
        
      ])
    ]),
  ]);
}

function onremove () {
  modal.off('closed');
}

module.exports = {oninit, view, onremove};
